import React from 'react';
import { Button, Flex, Typography, Space, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../Shared/GlobalContext/ThemeContext';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { ReactComponent as LogoWide } from '../../Images/logo-wide.svg';

const { Title, Text, Paragraph } = Typography;

const NotFound = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    return (
        <Flex
            vertical
            justify='center'
            align='center'
            style={{ 
                height: '100vh', 
                width: '100%',
                background: isDarkMode 
                    ? 'linear-gradient(135deg, #070605 0%, #161310 100%)' 
                    : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                padding: '24px',
                boxSizing: 'border-box'
            }}
        >
            <Card
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '16px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                    border: 'none',
                    overflow: 'hidden',
                    textAlign: 'center',
                }}
                bodyStyle={{ padding: 40 }}
            >
                <Flex vertical align="center" gap={24}>
                    <LogoWide width="180px" height="90px" style={{ marginBottom: '8px' }} />
                    
                    <div>
                        <Title 
                            level={1} 
                            style={{ 
                                fontSize: '72px', 
                                margin: 0,
                                background: 'linear-gradient(90deg, #4A90E2 0%, #7F56D9 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}
                        >
                            404
                        </Title>
                        <Paragraph style={{ fontSize: '16px', maxWidth: '400px', margin: '16px auto' }}>
                            {t('page_not_found_message', 'Sorry, the page you are looking for doesn\'t exist or has been moved.')}
                        </Paragraph>
                    </div>

                    <Space size="middle">
                        <Button 
                            type="primary" 
                            size="large"
                            icon={<HomeOutlined />}
                            onClick={() => navigate('/')}
                            style={{
                                height: '48px',
                                borderRadius: '8px',
                                background: '#4A90E2',
                                borderColor: '#4A90E2',
                                fontSize: '16px',
                                paddingLeft: '16px',
                                paddingRight: '20px'
                            }}
                        >
                            {t('back_home')}
                        </Button>
                        <Button 
                            size="large"
                            icon={<ArrowLeftOutlined />}
                            onClick={() => navigate(-1)}
                            style={{
                                height: '48px',
                                borderRadius: '8px',
                                fontSize: '16px',
                            }}
                        >
                            {t('go_back')}
                        </Button>
                    </Space>
                </Flex>
            </Card>
        </Flex>
    );
};

export default NotFound;
